<template>
  <div
    v-if="showCart && courseList && courseList.length"
    class="shoppping-cart"
  >
    <div v-if="isMobile" class="shoppping-cart-mobile">
      <img
        @click="moileBagClick"
        class="bag"
        src="../../../assets/images/shopping-cart/bag.png"
        alt=""
      />
      <!-- :modal="false" -->
      <!-- :before-close="handleClose" -->
      <el-drawer
        custom-class="cart-drawer"
        title=""
        :visible.sync="drawer"
        direction="btt"
        :wrapperClosable="false"
        append-to-body
      >
        <img
          @click="closeDrawer"
          class="close"
          src="../../../assets/images/close.png"
          alt=""
        />
        <cart-cont :courseList="courseList" :userList="userList" />
      </el-drawer>
    </div>

    <div v-else class="shoppping-cart-pc">
      <img
        class="bag"
        src="../../../assets/images/shopping-cart/bag.png"
        alt=""
      />
      <!-- :class="{ 'direction-left': direction }" -->
      <cart-cont
        :courseList="courseList"
        :userList="userList"
        class="direction-left"
      />
    </div>
  </div>
</template>

<script>
import { getRoomCartAll, getRoomCart } from "@saas/server-api/src/room-cart";
import CartCont from "./CartCont";
import { isMobile } from "@saas/components";
export default {
  props: {
    // direction: {
    //   type: String,
    //   default: "left", //top
    // },
    dplayer: {
      type: Object,
      default: () => {},
    },
    fullScreenStatus: {
      type: Boolean,
      default: false,
    },
    lessonId:{
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      showCart: false,
      userList: [],
      courseList: [],
      drawer: false,
      isMobile: isMobile(),
      roomCartList: [],
      currentTime: 0,
      currentCartId: 0,
      top: 0,
      isFullScreenShowDrawer: false, //全屏模式下显示的课程列表
    };
  },
  created() {
    this.initData();
    // setTimeout(() => {
    //   this.dplayer.seek(59);
    // }, 8000);
    // setTimeout(() => {
    //   this.dplayer.seek(1040);
    // }, 16000);
    // setTimeout(() => {
    //   this.dplayer.seek(1140);
    // }, 24000);
  },
  methods: {
    moileBagClick() {
      if (document.body.classList.value.includes("replay-landscape")) {
        this.isFullScreenShowDrawer = true;
        // document.body.classList.remove("replay-landscape");
        this.$emit("toggleFullScreen");
        // this.dplayer.fullScreen.cancel("web");
        setTimeout(() => {
          this.drawer = true;
        }, 700);
      } else {
        this.drawer = true;
      }
    },
    initData() {
      let params = {
        lesson_id: this.lessonId || this.$route.params.lessonId,
      };
      getRoomCartAll(params).then((res) => {
        if (res.code === 1) {
          if (res?.data?.length) {
            this.showCart = true;
            this.roomCartList = res.data;
            // 监听播放器时间
            this.dplayer.on("timeupdate", () => {
              this.currentTime = Math.floor(
                Number(this.dplayer.video.currentTime)
              );
            });
          } else {
            this.showCart = false;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleRoomCart(currentTime) {
      // console.log(
      //   currentTime,
      //   "currentTime",
      //   this.courseList,
      //   "courseList",
      //   this.currentCartId,
      //   "======"
      // );
      let showId = 0;
      for (let index = 0; index < this.roomCartList.length; index++) {
        const item = this.roomCartList[index];
        let { publish_time, stop_time, id } = item;
        // stop_time为0的，播放到结尾默认关闭就行了
        let lessStopTime = false;
        if (stop_time === 0 || currentTime < stop_time) {
          lessStopTime = true;
        }
        if (currentTime > publish_time && lessStopTime) {
          showId = id;
          break;
        } else if (currentTime === publish_time) {
          showId = id;
          break;
        } else if (currentTime === stop_time) {
          showId = 0;
          break;
        }
      }
      if (showId) {
        this.apiGetRoomCart(showId);
      } else {
        this.courseList = [];
        this.currentCartId = 0;
        if (this.isMobile) {
          this.drawer = false;
          this.isFullScreenShowDrawer = false;
        }
      }
    },
    apiGetRoomCart(id) {
      // console.log(id, "apiGetRoomCart=====");
      if (id === this.currentCartId) return;
      this.currentCartId = id;
      let params = {
        id,
        is_course_detail: true,
      };
      getRoomCart(params).then((res) => {
        if (res.code === 1) {
          let { course_map, course_ids } = res.data || {};
          if (course_map && course_ids?.length) {
            let arr = [];
            course_ids.forEach((item) => {
              if (course_map[item]) {
                arr.push(course_map[item]);
              }
            });
            this.courseList = arr;
          }
        }
      });
    },
    closeDrawer() {
      this.drawer = false;
      if (this.isFullScreenShowDrawer && this.isMobile) {
        this.$emit("toggleFullScreen");
        this.isFullScreenShowDrawer = false;
      }
    },
  },
  components: {
    CartCont,
  },
  watch: {
    currentTime: {
      handler(newValue) {
        if (this.showCart && typeof newValue === "number") {
          // console.log(newValue, "currentTime========");
          // 处理课程售卖信息
          this.handleRoomCart(this.currentTime);
        }
      },
      immediate: true,
    },
    fullScreenStatus: {
      handler(newValue, oldValue) {
        if (!this.isMobile) return;
        let elBag = document.querySelector(".shoppping-cart-mobile");
        if (!elBag) return;
        if (newValue) {
          elBag.style.top = "";
        } else {
          if (!this.top) {
            this.$nextTick(() => {
              setTimeout(() => {
                // 获取播放器
                let elVideo = document.querySelector(".dplayer-video-wrap");
                if (elVideo && !this.fullScreenStatus) {
                  let top = elVideo.offsetHeight + elVideo.offsetTop + 10;
                  console.log(top, "top====");
                  let elBag = document.querySelector(".shoppping-cart-mobile");
                  this.top = top;
                  elBag.style.top = `${top}px`;
                }
              }, 3000);
            });
          } else {
            elBag.style.top = `${this.top}px`;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.shoppping-cart-pc {
  position: relative;
  .bag {
    padding-top: 10px;
    padding-left: 10px;
    width: 66px;
    height: 66px;
    cursor: pointer;
    box-sizing: content-box;
  }
  .cart-cont {
    position: absolute;
    right: 0;
    bottom: 76px;
    opacity: 0;
    transition: all 0.3s ease;
    pointer-events: none;
  }
  &:hover {
    .cart-cont {
      opacity: 1;
      pointer-events: auto;
    }
  }
  .cart-cont.direction-left {
    position: absolute;
    right: 76px;
    bottom: 0;
  }
}
.shoppping-cart-mobile {
  position: fixed;
  top: 5.67rem;
  right: 0.4rem;
  width: 0.88rem;
  height: 0.88rem;
}
::v-deep .cart-drawer {
  height: auto !important;
  border-radius: 0.48rem 0.48rem 0rem 0rem;
  .close {
    position: absolute;
    top: 0.32rem;
    right: 0.32rem;
    width: 0.48rem;
    height: 0.48rem;
  }
  #el-drawer__title {
    display: none;
  }
  .el-drawer__body {
    overflow: hidden;
  }
}
</style>
<style lang="scss">
.replay-landscape {
  .replay-cart {
    z-index: 99999999 !important;
    position: fixed !important;
    bottom: 2.4rem !important;
    right: 0.4rem !important;
  }
  .shoppping-cart-mobile {
    width: 0.88rem;
    height: 0.88rem;
    position: static !important;
  }
}
</style>
